import { useCallback, useEffect, useState } from 'react';
import DateComp from '../../../core/common/dateComponent/DateComp';
import TextField from '../../../core/common/textFields/TextField';
import { useTableSelection } from '../../../core/hooks/useTableSelection';
import { useGetAllTeamsQuery } from '../../../services/EndPointsApis';
import { svgIcons } from '../../../style/fonts/SvgIcons';
import SidebarTeams from './SidebarTeams';
import NoRecordFound from '../../../core/common/noRecord/NoRecordFound';
import TableLoading from '../../../core/common/loadingComponent/TableLoading';
import { debounce } from 'lodash';
import Pagination from '../../../core/common/pagination/Pagination';
import Ribbon, { ToggleButton } from '../../../core/common/ribbon/ribbon';
import ActiveUserModal from './ActiveUserModal';
import FilterComponent from '../../../core/common/FilterComponent';
import TableHeading from '../../../core/common/tableHeading/TableHeading';
import FilterModalUser from '../manageUsers/FilterModalUser';
import { CSVLink } from 'react-csv';
import { initialColumnTeams } from './InitialColumnsTeams';
import dayjs from "dayjs";
import { Link } from 'react-router-dom';

const Teams = () => {
  const formattedDate = dayjs().format("YYYY-MM-DD_HH-mm-ss");

  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(15);
  const [searchStr, setSearchStr] = useState(''); // debounce search
  const [sortBy, setSortBy] = useState("createDT");
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortedColumn, setSortedColumn] = useState("createDT");
  const [immediateSearchStr, setImmediateSearchStr] = useState('')
  const [showActiveUserModal, setShowActiveUserModal] = useState(false)
  const [currentToggleState, setCurrentToggleState] = useState(false);
  const [showfilterModal, setShowfilterModal] = useState(false);
  const [teamsData, setTeamsData] = useState({});


  const { data: allTeams, refetch, isLoading } = useGetAllTeamsQuery({
    pageNumber: pageNumber,
    pageSize: pageSize,
    searchStr: searchStr || '',
    sortBy: sortBy,
    sortOrder: sortOrder,
  });
  const { data: allTeamsCSV } = useGetAllTeamsQuery({
    pageNumber: pageNumber,
    pageSize: pageSize,
    searchStr: searchStr || '',
    sortBy: sortBy,
    sortOrder: sortOrder,
  });

  const handlePageSizeChange = (selectedOption: any) => {
    setPageSize(selectedOption.value);
    setPageNumber(1);
  };
  // pagination
  const handlePageClick = (e: any) => {
    setPageNumber(e.selected + 1);
  };
  //per page record
  const handlePageRecords = (e: any) => {
    setPageNumber(1);
  };

  const handleSort = (property: string) => {
    setSortBy(property);
    if (sortedColumn === property) {
      setSortOrder(prevSortOrder => (prevSortOrder === "asc" ? "desc" : "asc"));
    } else {
      setSortedColumn(property);
      setSortOrder("asc");
    }
  };
  const idValue = 'dropdownMenuClickableInsise1';

  const handlefiltermodel = () => {
    setShowfilterModal(true);
    const dropdownToggle = document.getElementById(idValue);
    if (dropdownToggle) {
      dropdownToggle.click();
    }
  }

  const handleSearchChange = (e: any) => {
    const { value } = e.target;
    setImmediateSearchStr(value); // Update immediate search state
    delayedSearch(value); // Update debounced search state
  };
  const delayedSearch = useCallback(
    debounce((searchValue) => {
      setSearchStr(searchValue);
    }, 500),
    []
  );
  useEffect(() => {
    if (searchStr === "" ||
      sortOrder === "" ||
      sortBy === "") {
      refetch();
    }
  }, [searchStr, sortOrder, sortBy]);
  const {
    isTableHeadChecked,
    selectedIndividualCheckboxId,
    selectedItemData: teamData,
    handleTableHeadChange,
    handleCheckItem,
    handleRowClick,
    handleDelete,
    setSelectedIndividualCheckboxId
  } = useTableSelection(allTeams?.result?.data || [], 'id');

  const [activityToggleTeams, setActivityToggleTeams] = useState(false);
  const isAnyCheckboxChecked = selectedIndividualCheckboxId.length > 0;
  const isMoreThanOneChecked = selectedIndividualCheckboxId.length > 1;

  const [isEditing, setIsEditing] = useState(false);
  const [viewOnly, setViewOnly] = useState(false)

  const handleCloseStatusModal = () => {
    setShowActiveUserModal(false)
    setCurrentToggleState(!currentToggleState)
  };
  const handleAddTeams = () => {
    setActivityToggleTeams(true);
    setIsEditing(false);
  };

  const handleEditTeams = (data: any) => {
    setActivityToggleTeams(true);
    setIsEditing(true)
    setViewOnly(false)
    setTeamsData(data)
  };

  const closeSidebarTeams = (e: any) => {
    e?.preventDefault();
    setActivityToggleTeams(false);
    refetch();
    setSelectedIndividualCheckboxId([])
  };
  const handleToggle = () => {
    const newToggleState = !currentToggleState;
    setCurrentToggleState(newToggleState);
    setShowActiveUserModal(true);
  }
  const handleRowClicked = (data: any) => {
    handleRowClick(data);
    // setIsRowClicked(true);
    if (data?.status === true) {
      setCurrentToggleState(true)
    } else {
      setCurrentToggleState(false)
    }
  }
  const handleRefresh = () => {
    refetch()
  }
  const items = [
    {
      label: "Active",
      onClick: () => {
        setShowActiveUserModal(true);
      },
      ToggleButton: <ToggleButton
        onChange={handleToggle}
        id="toggle"
        checked={currentToggleState}
        disableButton={!isAnyCheckboxChecked || isMoreThanOneChecked} />
    },
    // {
    //   label: "Edit",
    //   tooltipLabel: "Edit User",
    //   icon: svgIcons.updateIcon,
    //   onClick: () => handleEditTeams(),
    //   disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked,
    //   disableIcon: svgIcons.updateIcon
    // },
    {
      label: "View",
      tooltipLabel: "View details", icon: svgIcons.eyeIcon,
      disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked,
      disableIcon: svgIcons.eyeIcon,
      // onClick: () => togglePopupformViewOnly(true),
      onClick: () => {
        setViewOnly(true);
        setActivityToggleTeams(true);
      },
    },
    { label: 'Refresh', tooltipLabel: "Refresh ", icon: <i className="ti ti-refresh-dot" aria-hidden="true"></i>, onClick: () => handleRefresh() },

  ]
  const handleClosefilterModal = () => {
    setShowfilterModal(false)
  };
  // csv data 
  const headers = initialColumnTeams.map(item => ({
    label: item.name,
    key: item.key,
  }));

  const CsvData = allTeamsCSV?.result?.data?.map((record: Record<string, any>) => {
    const csvRecord: Record<string, any> = {};
    headers?.forEach(header => {
      csvRecord[header.key] = record[header.key]?.value ?? record[header.key] ?? "";
    });
    return csvRecord;
  }) || []

  return (
    <>
      <ActiveUserModal
        show={showActiveUserModal}
        handleClose={handleCloseStatusModal}
        data={teamData}
        refetch={refetch}
        setCurrentToggleState={setCurrentToggleState}
        handleDelete={handleDelete}
      />
      <FilterModalUser show={showfilterModal} handleClose={handleClosefilterModal} />
      <SidebarTeams activityTogglePopup={activityToggleTeams} viewOnly={viewOnly} closeSidebar={closeSidebarTeams} isEditing={isEditing} data={teamsData} />
      <div className="page-wrapper">
        <div className="content">
          <div className='row m-0'>
            <div className='col-md-12 p-0'>
              <Ribbon
                items={items}
                buttonText="+ Add Team"
                buttonClass="add-popup ribbon-btn "
                onClickbtn={handleAddTeams}
                disabled={isAnyCheckboxChecked || isMoreThanOneChecked}
              />
            </div>
            <div className='card main-card'>
              <div className='card-body '>
                <div className='row align-items-center'>
                  <div className='col-md-4 col-sm-8'>
                    <h4 className='color-red mb-2'>
                      Teams
                    </h4>
                  </div>
                  <div className="col-md-8">
                    <div className="d-flex gap-2 flex-column flex-md-row justify-content-end">
                      <CSVLink data={CsvData} headers={headers} filename={`Teams_List ${formattedDate}.csv`} className="btn btn-light-red d-flex gap-1 align-items-center justify-content-center">
                        <i className="fa fa-file-export" />
                        Export To CSV
                      </CSVLink>
                      {/* <FilterComponent handlefiltermodel={handlefiltermodel} idValue={idValue} /> */}
                      <>
                        <div className="icon-form">
                          <span className="form-icon">
                            <i className="ti ti-search" />
                          </span>
                          <input
                            type="text"
                            className="form-control min-height"
                            placeholder="Search Team"
                            value={immediateSearchStr}
                            onChange={handleSearchChange}
                          />
                        </div>
                      </>
                    </div>
                  </div>
                </div>
                <div className="table-responsive custom-table mt-2">
                  <table className="table datanew dataTable no-footer table-hover">
                    <thead>
                      <tr>
                        <th>
                          {/* <input
                            type="checkbox"
                            className='form-check-input cursor-pointer'
                            checked={isTableHeadChecked}
                            onChange={handleTableHeadChange}
                          /> */}
                        </th>
                        <TableHeading
                          label='NAME'
                          sortedColumn='name'
                          columnId='name'
                          sortOrder='desc'
                          handleSort={handleSort}
                        />
                        <TableHeading
                          label='CREATED AT'
                          sortedColumn='createdDT'
                          columnId='createdDT'
                          sortOrder='desc'
                          handleSort={handleSort}
                        />
                        <TableHeading
                          label='MODIFIED ON'
                          sortedColumn='updatedDT'
                          columnId='updatedDT'
                          sortOrder='desc'
                          handleSort={handleSort}
                        />
                        <TableHeading
                          label='STATUS'
                          sortedColumn='status'
                          columnId='status'
                          sortOrder='desc'
                          handleSort={handleSort}
                        />
                      </tr>
                    </thead>
                    <tbody>
                      {!isLoading &&
                        <>
                          {allTeams?.result?.data?.length > 0 ? (
                            <>
                              {allTeams?.result?.data?.map((data: any, index: any) => {
                                return (
                                  <tr key={data.id} onClick={() => handleRowClicked(data)}
                                    className={selectedIndividualCheckboxId.includes(data.id) ? 'selected-row' : ''}>
                                    <td>
                                      <div className='d-flex gap-2'>
                                        <TextField
                                          type="checkbox"
                                          fieldClass='form-check-input cursor-pointer'
                                          checked={isTableHeadChecked || selectedIndividualCheckboxId.includes(data.id)}
                                          onChange={(e) => handleCheckItem(e, data)}
                                        />
                                        <div className='cursor-pointer' onClick={()=> handleEditTeams(data)}
                                        >
                                          {svgIcons.updateIcon}
                                        </div>
                                      </div>
                                    </td>
                                    <td>{data?.name}</td>
                                    <td><DateComp formattedDate={data?.createdDT} /></td>
                                    <td><DateComp formattedDate={data?.updatedDT} /></td>
                                    <td>
                                      {data?.status === true ? (
                                        <span className="badge badge-pill badge-status bg-soft-success text-success">Active</span>
                                      ) : (
                                        <span className="badge badge-pill badge-status bg-soft-danger text-danger">Inactive</span>
                                      )}
                                    </td>
                                  </tr>
                                )
                              })}
                            </>
                          ) :
                            (<tr>
                              <td colSpan={7}>
                                <NoRecordFound />
                              </td>
                            </tr>)}
                        </>
                      }

                      {isLoading &&
                        <TableLoading />
                      }
                    </tbody>
                  </table>
                </div>
                <Pagination
                  onChange={handlePageSizeChange}
                  pageSize={pageSize}
                  onPageChange={handlePageClick}
                  pageCount={allTeams?.result?.totalPages || 0}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Teams
